import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { IRideInvestigationHistorySupplierDto } from "@ryde/shared";

interface IInvestigationHistoryPayloadProps {
  supplier: IRideInvestigationHistorySupplierDto;
}

/** Supplier request/response bodies, collapsed — only sent to callers who may read provider logs. */
export const InvestigationHistoryPayload: FC<
  IInvestigationHistoryPayloadProps
> = ({ supplier }) => {
  const { t } = useTranslation();

  if (!supplier.requestPayload && !supplier.responsePayload) {
    return null;
  }

  return (
    <details className="history-payload">
      <summary>
        {t("rideMap.investigation.history.supplier.showPayload")}
      </summary>
      {supplier.requestPayload && (
        <>
          <h5>{t("rideMap.investigation.history.supplier.request")}</h5>
          <pre>{supplier.requestPayload}</pre>
        </>
      )}
      {supplier.responsePayload && (
        <>
          <h5>{t("rideMap.investigation.history.supplier.response")}</h5>
          <pre>{supplier.responsePayload}</pre>
        </>
      )}
    </details>
  );
};
